let throttle = {}; //节流

export const clearErrorCache = () => {
    for (let k in throttle) {
        clearTimeout(throttle[k])
    }
    throttle = {}
}